// src/firebase.js

import { initializeApp } from "firebase/app";
import {
  getDatabase,
  ref,
  push,
  onValue,
  remove,
  set,
  update,
  get
} from "firebase/database";
import { getStorage } from "firebase/storage"; // ✅ ADD THIS LINE

const firebaseConfig = {
  apiKey: "AIzaSyBQH2WrAThV4GfBggXES7HKVtO-Ax23rMU",
  authDomain: "jauharib-a673c.firebaseapp.com",
  databaseURL: "https://jauharib-a673c-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "jauharib-a673c",
  storageBucket: "jauharib-a673c.appspot.com",
  messagingSenderId: "353180744058",
  appId: "1:353180744058:web:488da324e65c67f478bec3",
  measurementId: "G-JKT0LQYJG8"
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const storage = getStorage(app); // ✅ INITIALIZE STORAGE

export {
  database,
  ref,
  push,
  onValue,
  remove,
  set,
  update,
  get,
  storage // ✅ EXPORT STORAGE
};
